import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { Icon } from "@iconify/react";
import "../../Assets/CSS/MyTask.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const MyTask = () => {
  const [activeTab, setActiveTab] = useState("PENDING");
  const [tasks, setTasks] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const PAGE_SIZE = 5;

  // 🔹 Status mapping (Backend → UI)
  const mapStatus = (status) => {
    switch (status) {
      case "PENDING":
        return "PENDING";
      case "IN_PROGRESS":
        return "In-progress";
      case "COMPLETED":
        return "Completed";
    
    }
  };

  // 🔹 API Call
  const fetchTasks = async (pageNo) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
       `${process.env.REACT_APP_BACKEND_URL}/tasks?page=${pageNo}&size=${PAGE_SIZE}&sort=asc`,
        {
           headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedTasks = res.data.content.map((item) => ({
        id: item.taskId,
        title: item.taskDescription,
        dueDate: item.endDate,
        project: item.projectName,
        projectClass: "project-blue",
        status: mapStatus(item.status),
      }));

      setTasks(formattedTasks);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching tasks", error);
    }
  };

  useEffect(() => {
    fetchTasks(page);
  }, [page]);

  // 🔹 Filter by tab
  const filteredTasks = tasks.filter(
    (task) => task.status === activeTab
  );


const handleMyTaskDetailPage = (taskId) => {
  navigate(`/mytaskdetailed/${taskId}`);
};


  return (
    <Layout>
      <div className="backgound-main-content">

        {/* Header */}
        <div className="d-flex align-items-center justify-content-between p-3" style={{ marginTop: "10px" }}>
          <button className="back-btn111 mb-3" onClick={() => navigate(-1)}>
            <Icon icon="akar-icons:arrow-left" width="18" /> Back
          </button>

          <button className="add-emp-button"  onClick={() => navigate("/createtask")}>
            <Icon icon="material-symbols:add-rounded" width="18" height="18" />
            <span className="button-text">New Task</span>
          </button>
        </div>

        {/* Heading */}
        <h4 className="mb-3 fw-semibold">
          My Tasks ({tasks.length})
        </h4>

        {/* Tabs */}
        <ul className="nav nav-tabs mb-3">
          {["PENDING", "In-progress", "Completed"].map((tab) => (
            <li className="nav-item" key={tab}>
              <button
                className={`nav-link ${activeTab === tab ? "active-tab" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}{" "}
                <span className="count">
                  ({tasks.filter((t) => t.status === tab).length})
                </span>
              </button>
            </li>
          ))}
        </ul>

        {/* Table */}
        <div className="table-responsive">
          <table className="table align-middle mytask-table">
            <thead>
              <tr>
                <th>List</th>
                <th>Due Date</th>
                <th>Project</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody className="tbaleb" >
              {filteredTasks.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    No tasks found
                  </td>
                </tr>
              ) : (
                filteredTasks.map((task) => (
                  <tr key={task.id} className="active-row"
                     style={{ cursor: "pointer" }}
  onClick={() => handleMyTaskDetailPage(task.id)}  // ✅ ONLY ID
                  >
                    <td className="task-title">{task.title}</td>
                    <td className="task-date">{task.dueDate}</td>
                    <td>
                      <span className={`project-badge ${task.projectClass}`}>
                        {task.project}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`status-badge ${task.status
                          .toLowerCase()
                          .replace("-", "")}`}
                      >
                        {task.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-end gap-2 mt-3">
          <button
            className="btn btn-light"
            disabled={page === 0}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <button
            className="btn btn-light"
            disabled={page === totalPages - 1}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>

      </div>
    </Layout>
  );
};

export default MyTask;
